import {combine, forward, merge} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {loadProfileFx, loginWithCertFx} from 'models/auth';

import {otpSuccessWithData} from 'models/auth/init';

import {createUserFx} from 'models/profile/staff/table';

import {
    createParticipantFx,
    data$,
    editParticipantData$,
    firs$,
    FIRSGate,
    getCredentialsFIRSFx,
    loadParticipantsDataFx,
    loadProfileCommonDataFx,
    loadProfileCountiesFx,
    onChangeParticipantIdForRemoveConfirmation,
    onSetEditParticipant,
    participantIdForRemoveConfirmation$,
    ParticipantsGate,
    participantsList$,
    profileCountries$,
    removeParticipantFx,
    setCredentialsFIRSFx,
    setUpdateParticipantRolesModalVisible,
    updateParticipantFx,
    updateParticipantRolesFx,
    updateParticipantRolesModalVisible$,
} from './index';

data$.on(loadProfileCommonDataFx.done, (_, {result}) => result);
profileCountries$.on(loadProfileCountiesFx.done, (_, {result}) => result);
editParticipantData$.on(onSetEditParticipant, (_, payload) => payload);
participantIdForRemoveConfirmation$
    .on(onChangeParticipantIdForRemoveConfirmation, (_, payload) => payload)
    .reset(ParticipantsGate.close);

firs$.on(getCredentialsFIRSFx.done, (_, {result}) => result).reset(ParticipantsGate.close);

participantsList$
    .on(loadParticipantsDataFx.done, (_, {result}) => result)
    .reset(ParticipantsGate.close);

forward({
    from: merge([ParticipantsGate.open, removeParticipantFx.done]),
    to: loadParticipantsDataFx,
});

forward({
    from: merge([
        // loginFx.done,
        otpSuccessWithData,
        loadProfileFx.done,
        loginWithCertFx.done,
        createUserFx.done,
    ]),
    to: [loadProfileCommonDataFx, loadProfileCountiesFx],
});

forward({
    from: FIRSGate.open,
    to: getCredentialsFIRSFx,
});

forward({
    from: setCredentialsFIRSFx.done,
    to: getCredentialsFIRSFx,
});

createParticipantFx.doneData.watch(() =>
    toast.success(i18next.t('pages.profile.participant.messages.success')),
);
updateParticipantFx.doneData.watch(() =>
    toast.success(i18next.t('pages.profile.participant.messages.update')),
);
removeParticipantFx.doneData.watch(() =>
    toast.success(i18next.t('pages.profile.participant.messages.removed')),
);

updateParticipantRolesModalVisible$
    .on(setUpdateParticipantRolesModalVisible, (_, payload) => payload)
    .reset(ParticipantsGate.close);

updateParticipantRolesFx.doneData.watch(() => {
    setUpdateParticipantRolesModalVisible(false);
    toast.success('Roles updated successfully');
});

forward({
    from: updateParticipantRolesFx.done,
    to: loadProfileFx,
});

export const $updateParticipantRolesPending = combine(
    updateParticipantRolesFx.pending,
    (pending) => pending,
);

[
    loadProfileCommonDataFx,
    loadProfileCountiesFx,
    loadParticipantsDataFx,
    createParticipantFx,
    updateParticipantFx,
    removeParticipantFx,
    updateParticipantRolesFx,
].forEach((fx) => fx.failData.watch((err) => showRestError(err as RestError)));
